import { render, staticRenderFns } from "./Sucker.vue?vue&type=template&id=18a41437&"
import script from "./Sucker.vue?vue&type=script&lang=js&"
export * from "./Sucker.vue?vue&type=script&lang=js&"
import style0 from "./Sucker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a41437')) {
      api.createRecord('18a41437', component.options)
    } else {
      api.reload('18a41437', component.options)
    }
    module.hot.accept("./Sucker.vue?vue&type=template&id=18a41437&", function () {
      api.rerender('18a41437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Sucker.vue"
export default component.exports